import angular, { IAttributes, IDirective, IScope } from 'angular';
import { RootScope } from '../../app.config';
import { UsersService } from '../../shared/users/users.service';
import { UserRole } from '../../src/app/@types/user';

const PermissionDirective: angular.IDirectiveFactory = (): IDirective => ({
  controller: (
    $scope: IScope,
    $rootScope: RootScope,
    $element: JQLite,
    $attrs: IAttributes,
    usersService: UsersService,
  ): void => {
    'ngInject';

    const toggleVisibility = (): boolean => {
      // Prevent the deletion of elements, before the user is logged in
      if (!$rootScope.globals.currentUser) return true;

      const userRoles: UserRole[] = usersService.getRolesOfCurrentUser();
      const isAdmin = userRoles.some((i) => i === UserRole.ADMIN);

      if (isAdmin) return true;

      // eslint-disable-next-line max-len
      const permissionString = $attrs.permission;
      const permissions = String(permissionString).split(',').map((s: string) => parseInt(s, 10));

      if (!(permissions as UserRole[]).some((a) => userRoles.includes(a))) {
        $element.remove();
      }
      return true;
    };

    /**
     * After the permissions are received by the server, validate the directive's visiblity.
     */
    $rootScope.$on('updatePermissionDirectives', () => {
      toggleVisibility();
    });

    toggleVisibility();
  },
  restrict: 'A',
  // scope: {
  //   permissions: '@?',
  // },
});

/**
 * This directive can toggle the visibility of elements if the user is allowed to see them or not.
 * The `permission` attribute defines `roles` which can access the element associated with.
 * After all permissions are received by the server,
 * all directives are called to validate the visibility.
 */
export default angular.module('services.permissionDirective', [])
  .directive('permission', PermissionDirective)
  .name;
